import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Dialog from "material-ui/Dialog";
import moment from "moment";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import { GrayButton, SecondaryButton, Spinner, PageHeader, CheckboxList } from "components";
import { LeftNavLayout } from "containers";
import { connect } from "react-redux";
import cookie from "js-cookie";
import { lookupInstagram, save, del, loadStagedSocialAccounts, setAccountToConnect, requestBusinessManagerPageAccess, checkBusinessManagerPageAccess, refreshFacebookToken, createReminderOnlyAccount } from "redux/modules/socialConnection";
import { loadFacebookAdAccount, verifyFacebookPixelInstallation } from "redux/modules/ads";
import { getSocialAccounts, subscribeOrgSocialAccountToWebhooks, getNotifiableContacts, upsertPostReminderSubscription } from "redux/modules/organization";
import TextField from "material-ui/TextField";
import _ from "lodash";
import SocialAccountList from "components/SocialAccountList/SocialAccountList";
import { socialAccountsDialogs } from "components/SocialAccountList/components";
import FacebookAdAccountConnectionModal from "components/SocialAccountList/FacebookAdAccountConnectionModal";
import styles from "./SocialAccounts.scss";
import { List, ListItem, makeSelectable } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import localStorage from "local-storage";
var SocialAccounts = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    user: state.auth.user,
    internalState: {},
    selectedAccounts: [],
    socialAccounts: state.organization.current.SocialAccounts,
    organization: state.organization.current,
    userSocialAccounts: state.auth.user.SocialAccounts,
    accountToConnect: state.socialConnection.accountToConnect,
    config: state.config,
    pixelVerifyUrl: state.ads.facebookPixelVerifyUrl,
    facebookPixel: state.ads.facebookPixels && state.ads.facebookPixels.length > 0 ? state.ads.facebookPixels[0] : null,
    notifiableContacts: state.organization && state.organization.current && state.organization.current.notifiableContacts ? state.organization.current.notifiableContacts : null
  };
}, {
  lookupInstagram: lookupInstagram,
  save: save,
  del: del,
  loadStagedSocialAccounts: loadStagedSocialAccounts,
  setAccountToConnect: setAccountToConnect,
  requestBusinessManagerPageAccess: requestBusinessManagerPageAccess,
  checkBusinessManagerPageAccess: checkBusinessManagerPageAccess,
  refreshFacebookToken: refreshFacebookToken,
  getSocialAccounts: getSocialAccounts,
  loadFacebookAdAccount: loadFacebookAdAccount,
  subscribeOrgSocialAccountToWebhooks: subscribeOrgSocialAccountToWebhooks,
  verifyFacebookPixelInstallation: verifyFacebookPixelInstallation,
  createReminderOnlyAccount: createReminderOnlyAccount,
  getNotifiableContacts: getNotifiableContacts,
  upsertPostReminderSubscription: upsertPostReminderSubscription
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SocialAccounts, _Component);

  var _super = _createSuper(SocialAccounts);

  function SocialAccounts(props) {
    var _this;

    _classCallCheck(this, SocialAccounts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "deleteSocialAccount", function () {
      var socialAccountId = _this.state.modalState.data.accountToDelete.id;
      var organizationId = _this.props.organization.id;

      _this.setState({
        modalState: _objectSpread(_objectSpread({}, _this.state.modalState), {}, {
          data: _objectSpread(_objectSpread({}, _this.state.modalState.data), {}, {
            loading: true
          })
        })
      });

      _this.props.del(organizationId, socialAccountId).then(function () {
        return _this.props.getSocialAccounts(organizationId);
      }).then(function () {
        _this.handleModalRequestClose();

        _this.clearQueryString();
      })["catch"](function (err) {
        console.error(err);

        _this.handleModalRequestClose();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "connectSocialAccount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var targetAccount;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              targetAccount = _this.props.userSocialAccounts.find(function (sa) {
                return "".concat(sa.id) === "".concat(_this.state.modalState.data.selected);
              });

              _this.setState({
                modalState: _objectSpread(_objectSpread({}, _this.state.modalState), {}, {
                  data: _objectSpread(_objectSpread({}, _this.state.modalState.data), {}, {
                    loading: true
                  })
                })
              });

              if (targetAccount) {
                _context.next = 7;
                break;
              }

              _this.handleModalRequestClose();

              _context.next = 11;
              break;

            case 7:
              _context.next = 9;
              return _this.props.save(_this.props.organization.id, [targetAccount]);

            case 9:
              _context.next = 11;
              return _this.props.getSocialAccounts(_this.props.organization.id);

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error(err);

            case 16:
              _context.prev = 16;

              _this.clearQueryString();

              _this.handleModalRequestClose();

              return _context.finish(16);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13, 16, 20]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleRequestConnection", function (platform) {
      var inPlaceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        displayConnectionOverlay: platform
      });

      console.log(process.env.SOCIAL_LOGIN_URL);
      var struct = [process.env.SOCIAL_LOGIN_URL, _.camelCase(platform), [["organizationId", _this.props.organization.id], ["token", encodeURIComponent(localStorage.get('accessToken'))], ["redirect", encodeURIComponent(window.location.href.split("?")[0].split("#")[0])], inPlaceUpdate && ["update", true]].filter(function (v) {
        return v;
      })].filter(function (v) {
        return v;
      });
      window.location.href = _.reduce(struct, function (acc, obj) {
        return obj instanceof Array ? "".concat(acc, "?").concat(obj.map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              field = _ref3[0],
              value = _ref3[1];

          return "".concat(field, "=").concat(value);
        }).join("&")) : "".concat(acc).concat(obj);
      }, "");
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestReminderOnlyConnection", function (platform) {
      switch (platform) {
        case "Instagram":
          return _this.handleModalOpen("instagram_reminder", {
            step: 0
          })();

        default:
          console.error("Unknown Reminder platform");
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalRequestClose", function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return true;
      };

      _this.setState({
        modalState: {
          open: false,
          data: {}
        }
      }, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalOpen", function (type) {
      var initialData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return function () {
        _this.setState({
          modalState: {
            open: type,
            data: initialData
          }
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "clearQueryString", function () {
      _this.props.router.push("/org/".concat(_this.props.organization.id, "/settings/social-accounts"));
    });

    _this.state = {
      loading: true,
      displayConnectionOverlay: false,
      postReminderSetupModal: null,
      modalState: {
        open: false,
        data: {}
      }
    };
    return _this;
  }

  _createClass(SocialAccounts, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.location && prevProps.location.query) {
        if ((prevProps.location.query.fbc === "true" || prevProps.location.query.lic === "true" || prevProps.location.query.gmbc === "true") && this.state.modalState.open !== "account_selection") {
          this.handleModalOpen("account_selection", {
            type: function () {
              var query = prevProps.location.query;
              var keys = Object.keys(query);

              if (keys.includes("fbc")) {
                return "Facebook page";
              } else if (keys.includes("lic")) {
                return "LinkedIn company";
              } else if (keys.includes("gmbc")) {
                return "Google my business";
              }
            }()
          })();
        } else if (prevProps.location.query.fbc !== "true" && prevProps.location.query.lic !== "true" && prevProps.location.query.gmbc !== "true" && this.state.modalState.open === "account_selection") {
          this.handleModalRequestClose();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _this$props$location$,
          _this$props$location$2;

      var inComposeModal = location.pathname.indexOf("compose") >= 0;
      this.props.loadFacebookAdAccount(this.props.organization.id)["catch"](function (err) {
        return console.error(err);
      });
      this.props.getSocialAccounts(this.props.organization.id).then(function (accounts) {
        _this2.setState({
          loading: false
        });

        accounts.data.forEach(function (a) {
          var tokenExpired = moment(a.tokenValidUntil).isBefore(moment());
          var needsTokenRefresh = moment(a.tokenValidUntil).isBefore(moment().add(10, "days"));

          if (a.platform == "Twitter") {
            needsTokenRefresh = false;
          }

          if (tokenExpired && !inComposeModal) {
            toast.error("Your ".concat(a.platform, " account needs to be reconnected."), {
              hideProgressBar: true,
              autoClose: false,
              position: "bottom-right"
            });
          } else if (needsTokenRefresh && !inComposeModal) {
            toast.warning("Your ".concat(a.platform, " account needs to be reconnected soon."), {
              hideProgressBar: true,
              autoClose: false,
              position: "bottom-right"
            });
          }
        });
      })["catch"](function (err) {
        console.error(err);

        _this2.setState({
          loading: false
        });
      });
      this.props.getNotifiableContacts(this.props.organization.id)["catch"](function (err) {
        return console.error(err);
      });

      if (["facebook", "twitter", "linkedin", "gmb"].includes((_this$props$location$ = this.props.location.query) === null || _this$props$location$ === void 0 ? void 0 : _this$props$location$.success)) {
        var name = function () {
          var _this2$props$location, _this2$props$location2;

          switch ((_this2$props$location = _this2.props.location.query) === null || _this2$props$location === void 0 ? void 0 : _this2$props$location.success) {
            case "gmb":
              return "Google My Business";

            case "linkedin":
              return "LinkedIn";

            default:
              return _.startCase((_this2$props$location2 = _this2.props.location.query) === null || _this2$props$location2 === void 0 ? void 0 : _this2$props$location2.success);
          }
        }();

        toast.success("\uD83D\uDC4D ".concat(name, " account connected successfully."), {
          position: toast.POSITION.TOP_CENTER
        });
      }

      if (["facebook", "twitter", "linkedin", "gmb"].includes((_this$props$location$2 = this.props.location.query) === null || _this$props$location$2 === void 0 ? void 0 : _this$props$location$2.error)) {
        var _this$props$location$3, _this$props$location$4;

        var _name = function () {
          var _this2$props$location3, _this2$props$location4;

          switch ((_this2$props$location3 = _this2.props.location.query) === null || _this2$props$location3 === void 0 ? void 0 : _this2$props$location3.error) {
            case "gmb":
              return "Google My Business";

            case "linkedin":
              return "LinkedIn";

            default:
              return _.startCase((_this2$props$location4 = _this2.props.location.query) === null || _this2$props$location4 === void 0 ? void 0 : _this2$props$location4.error);
          }
        }();

        toast.error("We couldn't connect your ".concat(_name, " account.").concat((_this$props$location$3 = this.props.location.query) !== null && _this$props$location$3 !== void 0 && _this$props$location$3.msg ? " ".concat((_this$props$location$4 = this.props.location.query) === null || _this$props$location$4 === void 0 ? void 0 : _this$props$location$4.msg) : ""), {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false
        });
      }

      this.props.getNotifiableContacts(this.props.organization.id)["catch"](function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      toast.dismiss();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var RemoveAccountDialog = socialAccountsDialogs.RemoveAccountDialog,
          AccountSelectionDialog = socialAccountsDialogs.AccountSelectionDialog,
          FacebookAdAccountConnection = socialAccountsDialogs.FacebookAdAccountConnection,
          FacebookPixelSetup = socialAccountsDialogs.FacebookPixelSetup,
          InstagramAdsConnection = socialAccountsDialogs.InstagramAdsConnection,
          InstagramReminderSetup = socialAccountsDialogs.InstagramReminderSetup,
          PostReminderSettings = socialAccountsDialogs.PostReminderSettings,
          AccountSettings = socialAccountsDialogs.AccountSettings;
      var socialAccountListData = this.state.modalState.open === "account_selection" ? _.uniqBy(_toConsumableArray(this.props.userSocialAccounts), function (obj) {
        return obj.platformId;
      }).filter(function (sa) {
        return sa.platform === _this3.state.modalState.data.type;
      }).filter(function (sa) {
        if (_this3.state.modalState.data.searchTerm) {
          return "".concat(sa.username).toLowerCase().indexOf("".concat(_this3.state.modalState.data.searchTerm).toLowerCase()) !== -1;
        }

        return true;
      }).map(function (sa) {
        return {
          id: sa.id,
          name: sa.username,
          picture: sa.avatarImageUrl,
          selected: "".concat(sa.id) === "".concat(_this3.state.modalState.data.selected)
        };
      }).sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }

        return 0;
      }) : [];
      var errorPlatform;

      switch (this.props.location.query.error) {
        case "linkedin":
          errorPlatform = "LinkedIn";
          break;

        case "twitter":
          errorPlatform = "Twitter";
          break;

        case "facebook":
          errorPlatform = "Facebook";
          break;

        case "instagram":
          errorPlatform = "Instagram";
          break;

        default:
          errorPlatform = this.props.location.query.error;
          break;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Social Accounts"
      }), !!this.state.displayConnectionOverlay && /*#__PURE__*/React.createElement("div", {
        className: styles.connectionOverlay
      }, /*#__PURE__*/React.createElement("h1", {
        style: {
          color: "#333333"
        }
      }, "Connecting to", " ", "".concat(this.state.displayConnectionOverlay).split(" ")[0]), /*#__PURE__*/React.createElement("p", {
        style: {
          color: "#333333"
        }
      }, "You will be redirected in a moment...")), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        style: {
          position: "relative"
        }
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RemoveAccountDialog, {
        open: this.state.modalState.open === "remove_account",
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        onFinish: this.deleteSocialAccount,
        disabled: this.state.modalState.data.loading === true
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Social Accounts"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(SocialAccountList, {
        organization: this.props.organization,
        user: this.props.user,
        config: this.props.config,
        socialAccounts: this.props.socialAccounts,
        getSocialAccounts: this.props.getSocialAccounts,
        handleRequestConnection: this.handleRequestConnection,
        handleRequestReminderOnlyConnection: this.handleRequestReminderOnlyConnection,
        requestBusinessManagerPageAccess: function requestBusinessManagerPageAccess(socialAccountId) {
          _this3.props.requestBusinessManagerPageAccess(_this3.props.organization.id, socialAccountId);

          _this3.handleModalOpen("facebook_ad_account", {
            phase: 0
          })();
        },
        handleDelete: function handleDelete(acct) {
          _this3.handleModalOpen("remove_account", {
            accountToDelete: acct
          })();
        },
        handleFacebookPixelTracking: function handleFacebookPixelTracking() {
          _this3.handleModalOpen("pixel_setup", {
            step: 1
          })();
        },
        subscribeAccountToWebhooks: function subscribeAccountToWebhooks(accountId) {
          _this3.props.subscribeOrgSocialAccountToWebhooks(_this3.props.organization.id, accountId);
        },
        openPageInstagramConnection: function openPageInstagramConnection() {
          _this3.handleModalOpen("instagram_ad_account", {
            step: 0,
            igAccount: false,
            accountValue: "",
            loading: false,
            account: null
          })();
        },
        handlePostReminderSettings: /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(account) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    try {
                      _this3.handleModalOpen("post_reminder_settings", {
                        account: account,
                        manualEmail: "",
                        manualUsers: [],
                        selected: []
                      })();
                    } catch (err) {
                      console.error(err);
                    }

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        onClickSettings: function onClickSettings(account) {
          _this3.handleModalOpen("account_settings_modal", {
            account: account
          })();
        }
      }))), /*#__PURE__*/React.createElement(AccountSelectionDialog, {
        open: this.state.modalState.open === "account_selection",
        onRequestClose: function onRequestClose() {
          _this3.handleModalRequestClose();

          _this3.clearQueryString();
        },
        onFinish: this.connectSocialAccount,
        disabled: this.state.modalState.data.loading === true,
        searchTerm: this.state.modalState.data.searchTerm,
        handleSearchTermChange: function handleSearchTermChange(e, val) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                searchTerm: val
              })
            })
          });
        },
        socialAccountList: socialAccountListData,
        handleAccountSelected: function handleAccountSelected(id) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                selected: id
              })
            })
          });
        }
      })))), /*#__PURE__*/React.createElement(FacebookPixelSetup, {
        open: this.state.modalState.open === "pixel_setup",
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        step: this.state.modalState.data.step,
        error: this.state.modalState.data.error,
        disabled: this.state.modalState.data.loading,
        incrementStep: function incrementStep() {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: _this3.state.modalState.data.step + 1
              })
            })
          });
        },
        decrementStep: function decrementStep() {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: _this3.state.modalState.data.step - 1
              })
            })
          });
        },
        verifyPixel: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        error: null,
                        loading: true
                      })
                    })
                  });

                  _context3.next = 4;
                  return _this3.props.verifyFacebookPixelInstallation(_this3.props.organization.id, _this3.props.pixelVerifyUrl, _this3.props.facebookPixel.id);

                case 4:
                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        error: null,
                        loading: false,
                        step: 3
                      })
                    })
                  });

                  _context3.next = 11;
                  break;

                case 7:
                  _context3.prev = 7;
                  _context3.t0 = _context3["catch"](0);
                  console.error(_context3.t0);

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        error: _context3.t0.error && _context3.t0.error.message ? _context3.t0.error.message : "We were not able to verify this pixel installation.",
                        loading: false
                      })
                    })
                  });

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 7]]);
        }))
      }), /*#__PURE__*/React.createElement(FacebookAdAccountConnection, {
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        open: this.state.modalState.open === "facebook_ad_account",
        disabled: this.state.modalState.data.loading === true,
        onFinish: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var account;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  account = _this3.props.socialAccounts ? _this3.props.socialAccounts.find(function (a) {
                    return a.platform === "Facebook page";
                  }) : null;

                  if (account) {
                    _context4.next = 4;
                    break;
                  }

                  throw new Error("Cannot find Facebook page");

                case 4:
                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        phase: 2,
                        loading: true
                      })
                    })
                  });

                  _context4.next = 7;
                  return _this3.props.checkBusinessManagerPageAccess(_this3.props.organization.id, account.id);

                case 7:
                  _context4.next = 9;
                  return Promise.all([_this3.props.loadFacebookAdAccount(_this3.props.organization.id), _this3.props.getSocialAccounts(_this3.props.organization.id)]);

                case 9:
                  _context4.next = 14;
                  break;

                case 11:
                  _context4.prev = 11;
                  _context4.t0 = _context4["catch"](0);
                  console.error(_context4.t0);

                case 14:
                  _context4.prev = 14;

                  _this3.handleModalRequestClose();

                  return _context4.finish(14);

                case 17:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 11, 14, 17]]);
        })),
        targetAccount: this.props.socialAccounts ? this.props.socialAccounts.find(function (a) {
          return a.platform === "Facebook page";
        }) : null,
        openFacebook: function openFacebook(account) {
          window.open("https://www.facebook.com/".concat(account.platformId, "/settings/?tab=admin_roles"));

          _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                phase: 1
              })
            })
          });
        },
        phaseIndex: this.state.modalState.data.phase
      }), /*#__PURE__*/React.createElement(InstagramAdsConnection, {
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        open: this.state.modalState.open === "instagram_ad_account",
        disabled: this.state.modalState.data.loading === true,
        step: this.state.modalState.data.step,
        instagramAccountData: this.state.modalState.data.igAccount,
        openFacebook: function openFacebook() {
          _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: 1
              })
            })
          });

          var fbPage = _this3.props.socialAccounts.find(function (a) {
            return a.platform === "Facebook page";
          });

          if (!fbPage) {
            return alert("You must first connect a Facebook page");
          }

          window.open("https://www.facebook.com/".concat(fbPage.platformId, "/settings/?tab=instagram_management"));
        },
        onFinish: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _yield$_this3$props$g, accounts, hasIg;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: true,
                        igAccount: false
                      })
                    })
                  });

                  _context5.prev = 1;
                  _context5.next = 4;
                  return _this3.props.getSocialAccounts(_this3.props.organization.id);

                case 4:
                  _yield$_this3$props$g = _context5.sent;
                  accounts = _yield$_this3$props$g.data;
                  hasIg = !!accounts.find(function (a) {
                    return a.platform.indexOf("Instagram") === 0;
                  });

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: false,
                        igAccount: {
                          attempted: true,
                          value: hasIg
                        }
                      })
                    })
                  });

                  if (hasIg) {
                    _this3.handleModalRequestClose();
                  }

                  _context5.next = 15;
                  break;

                case 11:
                  _context5.prev = 11;
                  _context5.t0 = _context5["catch"](1);

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: false,
                        igAccount: {
                          attempted: true,
                          value: false
                        }
                      })
                    })
                  });

                  _this3.handleModalRequestClose();

                case 15:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[1, 11]]);
        }))
      }), /*#__PURE__*/React.createElement(InstagramReminderSetup, {
        step: this.state.modalState.data.step,
        enteredAccount: this.state.modalState.data.account,
        onFinish: /*#__PURE__*/function () {
          var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref8) {
            var username, image, url, reminderResult, reminder;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    username = _ref8.username, image = _ref8.image, url = _ref8.url;
                    _context6.prev = 1;

                    _this3.setState({
                      modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                        data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                          loading: true
                        })
                      })
                    });

                    _context6.next = 5;
                    return _this3.props.createReminderOnlyAccount(_this3.props.organization.id, "Instagram", username, username, url, image);

                  case 5:
                    reminderResult = _context6.sent;
                    reminder = reminderResult.data.reminder;
                    _context6.next = 9;
                    return _this3.props.getSocialAccounts(_this3.props.organization.id);

                  case 9:
                    _this3.handleModalRequestClose(function () {
                      _this3.setState({
                        modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                          reminder: reminder,
                          open: "post_reminder_settings"
                        })
                      });
                    });

                    _context6.next = 16;
                    break;

                  case 12:
                    _context6.prev = 12;
                    _context6.t0 = _context6["catch"](1);
                    console.error(_context6.t0);

                    _this3.setState({
                      modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                        data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                          loading: false
                        })
                      })
                    });

                  case 16:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, null, [[1, 12]]);
          }));

          return function (_x2) {
            return _ref9.apply(this, arguments);
          };
        }(),
        handleAccountLoad: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var accountValue, _yield$_this3$props$l, data;

          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.prev = 0;
                  accountValue = _this3.state.modalState.data.accountValue;

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: true
                      })
                    })
                  });

                  _context7.next = 5;
                  return _this3.props.lookupInstagram(accountValue);

                case 5:
                  _yield$_this3$props$l = _context7.sent;
                  data = _yield$_this3$props$l.data;

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: false,
                        account: data,
                        step: 3
                      })
                    })
                  });

                  _context7.next = 14;
                  break;

                case 10:
                  _context7.prev = 10;
                  _context7.t0 = _context7["catch"](0);
                  console.error(_context7.t0);

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: false
                      })
                    })
                  });

                case 14:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, null, [[0, 10]]);
        })),
        onChangeAccount: function onChangeAccount(e, val) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                accountValue: val
              })
            })
          });
        },
        skipToStep: function skipToStep(step) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: step
              })
            })
          });
        },
        incrementStep: function incrementStep() {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: _this3.state.modalState.data.step + 1
              })
            })
          });
        },
        decrementStep: function decrementStep() {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                step: _this3.state.modalState.data.step - 1
              })
            })
          });
        },
        loading: this.state.modalState.data.loading,
        accountValue: this.state.modalState.accountValue,
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        open: this.state.modalState.open === "instagram_reminder",
        pageInstagram: this.props.socialAccounts.find(function (a) {
          return a.platform === "Instagram[page_connected]";
        })
      }), /*#__PURE__*/React.createElement(PostReminderSettings, {
        isSMB: "".concat(this.props.organization.organizationTypeId) === "3" && !this.props.user.isPartner,
        loading: this.state.modalState.data.loading,
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        open: this.state.modalState.open === "post_reminder_settings",
        reminder: this.state.modalState.reminder,
        account: this.state.modalState.data.account,
        notifiableContacts: _objectSpread(_objectSpread({}, this.props.notifiableContacts), function () {
          var manualA = [];

          if (_this3.state.modalState.data.manualUsers && _this3.state.modalState.data.manualUsers.length > 0) {
            manualA.push.apply(manualA, _toConsumableArray(_this3.state.modalState.data.manualUsers));
          }

          if (_this3.state.modalState.data.account && _this3.state.modalState.data.account.PostReminders && _this3.state.modalState.data.account.PostReminders.length > 0) {
            var account = _this3.state.modalState.data.account;
            manualA.push.apply(manualA, _toConsumableArray(account && account.PostReminders && account.PostReminders.length > 0 ? _toConsumableArray(account.PostReminders).reduce(function (acc, obj) {
              if (obj.PostReminderSubscriptions && obj.PostReminderSubscriptions.length > 0) {
                return acc.concat(_toConsumableArray(obj.PostReminderSubscriptions).filter(function (s) {
                  return !s.UserId;
                }).map(function (s) {
                  return s.emailAddress;
                }));
              }

              return acc;
            }, []) : []));
          }

          return manualA && manualA.length > 0 ? {
            "Manual Users": manualA
          } : {};
        }()),
        selected: this.state.modalState.data.selected,
        onChange: function onChange(selected) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                selected: selected
              })
            })
          });
        },
        handleAddManualEmail: function handleAddManualEmail() {
          if (_this3.state.modalState.data.manualEmail && validator.isEmail(_this3.state.modalState.data.manualEmail)) {
            _this3.setState({
              modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                  manualEmail: "",
                  manualUsers: [].concat(_toConsumableArray(_this3.state.modalState.data.manualUsers), [{
                    name: "",
                    picture: null,
                    email: _this3.state.modalState.data.manualEmail,
                    user: null
                  }])
                })
              })
            });
          }
        },
        manualEmailValue: this.state.modalState.data.manualEmail,
        handleManualEmailValueChanged: function handleManualEmailValueChanged(e, val) {
          return _this3.setState({
            modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
              data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                manualEmail: val
              })
            })
          });
        },
        onFinish: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var modalData, reminderId;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.prev = 0;

                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: true
                      })
                    })
                  });

                  modalData = _this3.state.modalState.data;
                  reminderId = -1;

                  if (_this3.state.modalState.reminder && _this3.state.modalState.reminder.id) {
                    reminderId = _this3.state.modalState.reminder.id;
                  } else {
                    reminderId = modalData.account.PostReminders[0].id;
                  }

                  _context8.next = 7;
                  return _this3.props.upsertPostReminderSubscription(_this3.props.organization.id, reminderId, modalData.selected.map(function (s) {
                    return {
                      id: function () {
                        var u = Object.keys(_objectSpread({}, _this3.props.notifiableContacts)).reduce(function (acc, key) {
                          return acc.concat(_this3.props.notifiableContacts[key]);
                        }, []).find(function (c) {
                          return c.email === s;
                        });
                        return u && u.user ? u.user.id : null;
                      }(),
                      email: s
                    };
                  }));

                case 7:
                  _context8.next = 9;
                  return _this3.props.getSocialAccounts(_this3.props.organization.id);

                case 9:
                  _this3.setState({
                    modalState: _objectSpread(_objectSpread({}, _this3.state.modalState), {}, {
                      data: _objectSpread(_objectSpread({}, _this3.state.modalState.data), {}, {
                        loading: false
                      })
                    })
                  });

                  _context8.next = 15;
                  break;

                case 12:
                  _context8.prev = 12;
                  _context8.t0 = _context8["catch"](0);
                  console.error(_context8.t0);

                case 15:
                  _context8.prev = 15;

                  _this3.handleModalRequestClose();

                  return _context8.finish(15);

                case 18:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[0, 12, 15, 18]]);
        }))
      }), /*#__PURE__*/React.createElement(AccountSettings, {
        open: this.state.modalState.open === "account_settings_modal",
        account: this.state.modalState.data.account,
        onRequestClose: function onRequestClose() {
          return _this3.handleModalRequestClose();
        },
        organization: this.props.organization
      }), /*#__PURE__*/React.createElement(ToastContainer, null));
    }
  }]);

  return SocialAccounts;
}(Component)) || _class);
export { SocialAccounts as default };